import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid, Modal, Typography } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./styles";

/**
 * Audit Completion Component
 */
export default ({ message }) => {
    let navigate = useNavigate();
    const classes = makeStyles(styles)();
    const { t } = useTranslation();
    const [completeMessage, setCompleteMessage] = useState(message);
    const { auditId } = useParams();
    const hideMessage = () => setCompleteMessage(false);
    const onSubmitAudit = () => {
        navigate(`/auth/audits/${auditId}/submit`);
        setCompleteMessage(false);
    };
    const onContinueAudit = () => hideMessage();

    return (
        <Modal
            open={completeMessage}
            aria-labelledby="message-modal"
            aria-describedby="audit-completion-modal"
        >
            <Grid container className={classes.modalBox}>
                <Grid>
                    <Typography
                        id="modal-description"
                        className={classes.modalMessage}
                        component="div"
                    >
                        {t("messages.auditCompletionPrompt")}
                    </Typography>
                </Grid>
                <Grid className={classes.modalActions}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onSubmitAudit}
                        size="small"
                    >
                        {t("submitAudit")}
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={onContinueAudit}
                    >
                        {t("continueAudit")}
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
};
